import BaseAnalyticsController from "./analytics/base_controller";

export default class extends BaseAnalyticsController {
  declare readonly eventNameValue: string;

  static values = {
    eventName: String,
  };

  trackAction() {
    this.trackEvent(this.eventNameValue);
  }
}
